import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Import Capacitor for native app detection
import { Capacitor } from '@capacitor/core';

// Register service worker for PWA (only on web)
if ('serviceWorker' in navigator && !Capacitor.isNativePlatform()) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((registration) => {
        console.log('SW registered:', registration.scope);
        // Check for updates on every page load
        registration.update();
      })
      .catch((error) => {
        console.log('SW registration failed:', error);
      });
  });

  // When SW activates a new version, reload once so user sees new code
  let hasReloaded = false;
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data?.type === 'SW_UPDATED' && !hasReloaded) {
      hasReloaded = true;
      console.log('[SW] New version active, reloading...');
      window.location.reload();
    }
  });
}

// Log platform info
console.log('Platform:', Capacitor.getPlatform());
console.log('Is Native:', Capacitor.isNativePlatform());

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

